import {ReactNode} from 'react'
import { Container} from 'react-bootstrap'

type MultiSelectFormWraperProps = {
    children: ReactNode
}


const MultiSelectFormWraper = ({children}:MultiSelectFormWraperProps) => {
    return (
        <Container>
                {children}
        </Container>
    )
}
export default MultiSelectFormWraper;
